import { render, staticRenderFns } from "./propaganda-add.vue?vue&type=template&id=bd8054ea&scoped=true&"
import script from "./propaganda-add.vue?vue&type=script&lang=js&"
export * from "./propaganda-add.vue?vue&type=script&lang=js&"
import style0 from "./propaganda-add.vue?vue&type=style&index=0&id=bd8054ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8054ea",
  null
  
)

export default component.exports